export const AUTHORIZED_CLINICIAN_ROLES = [
  'staff',
  'superadmin',
  'superuser',
  'super_admin',
  'admin',
  'nurse',
  'nurse_reviewer',
  'coordinator',
  'provider_clinician',
  'clinician_reviewer',
  'management',
  'operations',
];

export const isAuthorizedClinicianRole = (role) => {
  if (!role) return false;
  return AUTHORIZED_CLINICIAN_ROLES.includes(String(role).toLowerCase());
};

export const MATCH_ORIGIN = {
  PATIENT_INTEREST: 'patient_interest',
  AI_UNILATERAL: 'ai_unilateral',
};

export const describeMatchOrigin = (origin) => {
  if (origin === MATCH_ORIGIN.PATIENT_INTEREST) {
    return {
      key: MATCH_ORIGIN.PATIENT_INTEREST,
      label: 'Patient requested this trial',
      detail: 'The patient expressed interest in this trial and wants to connect.',
    };
  }
  return {
    key: MATCH_ORIGIN.AI_UNILATERAL,
    label: 'AI match — patient did not request this trial',
    detail: 'The patient registered or uploaded records, and CureGate AI matched them to this trial without an explicit interest.',
  };
};
